import { apiClient } from "../config";

async function getOrganizationProfile(Id: any) {
    const res = await apiClient.get(`/admin/organizations/${Id}`);
    return res.data;
  }
  
  export default getOrganizationProfile;